import request from '@/utils/request'

// 题库

let QuestionLibraryApi = {

    /*列表*/
    getList(data, errorback) {
        return request._post('/shop/study.question_library/index', data, errorback);
    },

    /*添加*/
    add(data, errorback) {
        return request._post('/shop/study.question_library/add', data, errorback);
    },

    /*删除*/
    del(data, errorback) {
        return request._post('/shop/study.question_library/del', data, errorback);
    },

    /*编辑*/
    edit(data, errorback) {
        return request._post('/shop/study.question_library/edit', data, errorback);
    },

    /*状态*/
    status(data, errorback) {
      return request._post('/shop/study.question_library/status', data, errorback);
    },

    /*导入*/
    import(data, errorback) {
        return request._post('/shop/study.question_library/import', data, errorback);
    },
    
    /*批量*/
    batch(data, errorback) {
        return request._post('/shop/study.question_library/batch', data, errorback);
    },
}

export default QuestionLibraryApi;



// WEBPACK FOOTER //
// ./src/api/study/question_library.js